import {Component, Injector, OnInit} from "@angular/core";
import {NgxPermissionsService} from "ngx-permissions";
import {EPermission} from "@city-tax/shared";
import {Observable} from "rxjs";
import {HexaDetailComponent, HexaWithPermissions} from "@hexalang/ui/core";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: "city-tax-feature-individual-filing-mi",
  templateUrl: "./individual-filing-mi.component.html",
  styleUrls: ["./individual-filing-mi.component.scss"],
})
export class IndividualFilingMiComponent
  extends HexaWithPermissions(HexaDetailComponent)
  implements OnInit {

  public ePermission = EPermission;
  public hasPermission$: Observable<any>;

  constructor(
    injector: Injector,
    public toastrService: ToastrService,
    public permissionService: NgxPermissionsService,
  ) {
    super(injector);
  }

  async ngOnInit() {
    this.checkPermission(EPermission.INDIVIDUAL_FILING_MI);
  }
}
